// extracted by mini-css-extract-plugin
export default {"trigger":"RmInfo_trigger__ySAoG","popover":"RmInfo_popover__ZiczC","description":"RmInfo_description__Mxl1J"};